import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiChangeField extends Layout {
    buttonChangeFields: Button;
    sourceEdiChangeField: DataSource;
    tableChangeField: Table;
}
